/*=========================================================================================
  File Name: module-licenseinfo-getters.js
  Description: LicenseInfo Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import commonFunc from '@/common/commonFunction';
export default {
	lstCertConnect(state) {
		return state.lstCertConnect;
	},
	compensCertStatus(state) {
		return state.compensCertStatus;
	},
	compensCertSuccess(state) {
		return state.compensCertSuccess;
	},
	compensCertLoading(state) {
		return state.compensCertLoading;
	},
	compensCertStep(state) {
		return state.compensCertStep;
	},
	compensCertData(state) {
		return state.compensCertData;
	},
	compensCertLastShownDate(state) {
		return state.compensCertLastShownDate;
	},
	compensCertList(state) {
		return state.compensCertList;
	},
	selectedCompensCert(state) {
		return state.selectedCompensCert;
	}
};
